import React, { useState, useEffect } from "react";
import { FaUserPlus, FaTrash, FaExclamationTriangle, FaChevronDown } from "react-icons/fa";
import { addClient, deleteOrdersAndClient, getClients } from "../utility/EndPointGoogleFirebase";

function ManageClient() {
  const [input, setInput] = useState("");
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleteSectionOpen, setIsDeleteSectionOpen] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [clientToDelete, setClientToDelete] = useState(null);
  const [notification, setNotification] = useState(null);

  const showNotification = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const fetchClients = () => {
    setIsLoading(true);
    getClients()
      .then((data) => { setClients(data.sort()); setIsLoading(false); })
      .catch(() => { showNotification("Errore nel caricamento clienti.", "error"); setIsLoading(false); });
  };

  useEffect(() => { fetchClients(); }, []);

  const handleAdd = () => {
    const clientName = input.trim().toUpperCase();
    if (!clientName) { showNotification("Devi inserire un nome cliente.", "error"); return; }
    if (clients.includes(clientName)) { showNotification(`"${clientName}" è già presente.`, "info"); setInput(""); return; }
    addClient(clientName)
      .then(() => {
        showNotification(`Cliente "${clientName}" aggiunto con successo.`, "success");
        setInput("");
        fetchClients();
        // Notifica Orders.jsx (e altri) che la lista clienti è cambiata
        window.dispatchEvent(new CustomEvent("clientsUpdated"));
      })
      .catch(() => showNotification("Errore durante l'aggiunta.", "error"));
  };

  const handleDeleteConfirmed = () => {
    if (!clientToDelete) return;
    deleteOrdersAndClient(clientToDelete)
      .then(() => {
        showNotification(`"${clientToDelete}" cancellato.`, "success");
        setIsConfirmModalVisible(false);
        setClientToDelete(null);
        fetchClients();
        // Notifica Orders.jsx (e altri) che la lista clienti è cambiata
        window.dispatchEvent(new CustomEvent("clientsUpdated"));
      })
      .catch(() => {
        showNotification("Errore durante la cancellazione.", "error");
        setIsConfirmModalVisible(false);
        setClientToDelete(null);
      });
  };

  const notifColors = {
    error:   { bg: "#fff1f2", color: "#be123c", border: "#fecdd3" },
    success: { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" },
    info:    { bg: "#eef2ff", color: "#4338ca", border: "#c7d2fe" },
  };

  const sectionCard = {
    background: "#fff",
    borderRadius: 14,
    border: "1px solid #e5e7eb",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  };

  const inputStyle = {
    flex: 1,
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    fontSize: 14,
    color: "#111827",
    background: "#fff",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    WebkitAppearance: "none",
    appearance: "none",
    minWidth: 0,
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500&display=swap');
        * { box-sizing: border-box; }

        .mcl-wrapper {
          max-width: 680px; margin: 0 auto;
          padding: 16px 12px;
          padding-left: max(12px, env(safe-area-inset-left));
          padding-right: max(12px, env(safe-area-inset-right));
          padding-bottom: max(32px, env(safe-area-inset-bottom));
          display: flex; flex-direction: column; gap: 16px;
        }
        @media (min-width: 480px) { .mcl-wrapper { padding: 20px 16px; } }
        @media (min-width: 768px) { .mcl-wrapper { padding: 32px 24px; } }

        .page-title {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: clamp(22px, 5vw, 34px);
          font-weight: 400; color: #111827; line-height: 1.2;
        }

        .mcl-add-btn {
          display: flex; align-items: center; justify-content: center; gap: 7px;
          padding: 10px 22px; border-radius: 9px; border: none;
          background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
          color: #fff; font-size: 14px; font-weight: 500;
          cursor: pointer; font-family: inherit; white-space: nowrap;
          transition: transform 0.15s, box-shadow 0.15s;
          -webkit-tap-highlight-color: transparent;
          flex-shrink: 0;
        }
        @media (hover: hover) {
          .mcl-add-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(79,70,229,0.28); }
        }
        .mcl-add-btn:active { transform: scale(0.98); }

        .mcl-input:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.1); }

        .mcl-accordion-header {
          display: flex; align-items: center; justify-content: space-between; gap: 8px;
          padding: 14px 16px; cursor: pointer;
          user-select: none; -webkit-tap-highlight-color: transparent;
          border-radius: 14px;
          transition: background 0.15s;
        }
        .mcl-accordion-header:hover { background: #fef2f2; }
        .mcl-accordion-header.open { background: #fff1f2; border-radius: 14px 14px 0 0; }

        .mcl-chevron {
          color: #9ca3af; font-size: 12px; flex-shrink: 0;
          transition: transform 0.25s ease;
        }
        .mcl-chevron.open { transform: rotate(180deg); color: #dc2626; }

        .mcl-table { width: 100%; border-collapse: collapse; }
        .mcl-th {
          padding: 9px 16px; text-align: left;
          font-size: 11px; font-weight: 500; color: #9ca3af;
          letter-spacing: 0.06em; text-transform: uppercase;
          background: #f9fafb; border-bottom: 1px solid #e5e7eb;
        }
        .mcl-td {
          padding: 12px 16px; font-size: 13px; color: #374151;
          border-bottom: 1px solid #f3f4f6; vertical-align: middle;
        }
        .mcl-tr:last-child .mcl-td { border-bottom: none; }
        @media (hover: hover) { .mcl-tr:hover .mcl-td { background: #fef2f2; } }

        .mcl-del-btn {
          display: flex; align-items: center; justify-content: center;
          width: 32px; height: 32px;
          border-radius: 8px; border: 1px solid #fecaca;
          background: #fff1f2; color: #dc2626;
          font-size: 13px; cursor: pointer; font-family: inherit;
          transition: all 0.15s; -webkit-tap-highlight-color: transparent;
        }
        @media (hover: hover) {
          .mcl-del-btn:hover { background: #fee2e2; border-color: #f87171; box-shadow: 0 2px 6px rgba(220,38,38,0.15); }
        }
        .mcl-del-btn:active { transform: scale(0.95); }

        .mcl-loader-ring {
          width: 24px; height: 24px;
          border: 2px solid #e5e7eb; border-top-color: #4f46e5;
          border-radius: 50%; animation: mclSpin 0.8s linear infinite;
          margin: 24px auto;
        }
        @keyframes mclSpin { to { transform: rotate(360deg); } }

        .mcl-modal-overlay {
          position: fixed; inset: 0; z-index: 50;
          display: flex; align-items: center; justify-content: center;
          padding: 16px;
          background: rgba(17,24,39,0.45);
          backdrop-filter: blur(3px);
          -webkit-backdrop-filter: blur(3px);
        }
        .mcl-modal {
          background: #fff; border-radius: 16px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          padding: 28px 24px; width: 100%; max-width: 360px;
        }
        .mcl-modal-cancel {
          flex: 1; padding: 10px; border-radius: 8px;
          border: 1px solid #e5e7eb; background: #f9fafb;
          color: #374151; font-size: 14px; font-weight: 500;
          cursor: pointer; font-family: inherit;
          transition: background 0.15s;
        }
        @media (hover: hover) { .mcl-modal-cancel:hover { background: #f3f4f6; } }
        .mcl-modal-confirm {
          flex: 1; padding: 10px; border-radius: 8px;
          border: none;
          background: linear-gradient(135deg, #dc2626, #ef4444);
          color: #fff; font-size: 14px; font-weight: 500;
          cursor: pointer; font-family: inherit;
          transition: transform 0.15s, box-shadow 0.15s;
        }
        @media (hover: hover) {
          .mcl-modal-confirm:hover { transform: translateY(-1px); box-shadow: 0 4px 14px rgba(220,38,38,0.3); }
        }
      `}</style>

      {/* Notification */}
      {notification && (
        <div style={{
          position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)",
          zIndex: 60, padding: "12px 20px", borderRadius: 10,
          border: `1px solid ${notifColors[notification.type]?.border}`,
          background: notifColors[notification.type]?.bg,
          color: notifColors[notification.type]?.color,
          fontSize: 13, fontWeight: 500,
          boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
          whiteSpace: "nowrap",
        }}>
          {notification.message}
        </div>
      )}

      <div className="mcl-wrapper">

        {/* Page header */}
        <div style={{ textAlign: "center", paddingBottom: 20, borderBottom: "1px solid #e5e7eb" }}>
          <p style={{ fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase", color: "#9ca3af", marginBottom: 6 }}>
            Gestione
          </p>
          <h1 className="page-title">Clienti</h1>
          <div style={{ width: 28, height: 2, background: "#4f46e5", borderRadius: 2, margin: "10px auto 0" }} />
        </div>

        {/* Add client */}
        <div style={sectionCard}>
          <div style={{ padding: "14px 16px", borderBottom: "1px solid #f3f4f6" }}>
            <h2 style={{ fontSize: 15, fontWeight: 500, color: "#111827", margin: 0, display: "flex", alignItems: "center", gap: 8 }}>
              <FaUserPlus style={{ color: "#4f46e5", fontSize: 14 }} />
              Nuovo cliente
            </h2>
          </div>
          <div style={{ padding: "14px 16px" }}>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAdd()}
                placeholder="Nome cliente"
                className="mcl-input"
                style={inputStyle}
              />
              <button onClick={handleAdd} className="mcl-add-btn">
                <FaUserPlus style={{ fontSize: 13 }} />
                Aggiungi
              </button>
            </div>
          </div>
        </div>

        {/* Delete section — accordion */}
        <div style={sectionCard}>
          <div
            className={`mcl-accordion-header${isDeleteSectionOpen ? " open" : ""}`}
            onClick={() => setIsDeleteSectionOpen((v) => !v)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <FaTrash style={{ color: "#dc2626", fontSize: 13, flexShrink: 0 }} />
              <span style={{ fontSize: 15, fontWeight: 500, color: "#111827" }}>
                Cancellazione cliente
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{
                fontSize: 12, fontWeight: 500,
                background: "#f9fafb", color: "#6b7280",
                padding: "3px 10px", borderRadius: 100,
                border: "1px solid #e5e7eb",
              }}>
                {clients.length} clienti
              </div>
              <FaChevronDown className={`mcl-chevron${isDeleteSectionOpen ? " open" : ""}`} />
            </div>
          </div>

          {isDeleteSectionOpen && <div style={{ height: 1, background: "#f3f4f6" }} />}

          {isDeleteSectionOpen && (
            <div style={{ overflowX: "auto" }}>
              {isLoading ? (
                <div className="mcl-loader-ring" />
              ) : clients.length === 0 ? (
                <p style={{ padding: "20px 16px", fontSize: 13, color: "#9ca3af", textAlign: "center" }}>
                  Nessun cliente trovato.
                </p>
              ) : (
                <table className="mcl-table">
                  <thead>
                    <tr>
                      <th className="mcl-th">#</th>
                      <th className="mcl-th">Nome cliente</th>
                      <th className="mcl-th" style={{ textAlign: "center", width: 56 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {clients.map((client, idx) => (
                      <tr key={idx} className="mcl-tr">
                        <td className="mcl-td" style={{ color: "#9ca3af", width: 40 }}>{idx + 1}</td>
                        <td className="mcl-td" style={{ fontWeight: 500, color: "#111827" }}>{client}</td>
                        <td className="mcl-td" style={{ textAlign: "center" }}>
                          <button
                            onClick={() => { setClientToDelete(client); setIsConfirmModalVisible(true); }}
                            className="mcl-del-btn"
                            title={`Elimina ${client}`}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>

      </div>

      {/* Confirm modal */}
      {isConfirmModalVisible && (
        <div className="mcl-modal-overlay" onClick={() => setIsConfirmModalVisible(false)}>
          <div className="mcl-modal" onClick={(e) => e.stopPropagation()}>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div style={{
                width: 48, height: 48, borderRadius: "50%",
                background: "#fff1f2", border: "1px solid #fecaca",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 16px",
              }}>
                <FaExclamationTriangle style={{ color: "#dc2626", fontSize: 20 }} />
              </div>
              <h3 style={{ fontSize: 16, fontWeight: 500, color: "#111827", margin: "0 0 8px" }}>
                Conferma cancellazione
              </h3>
              <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6, margin: 0 }}>
                Sei sicuro di voler cancellare <strong style={{ color: "#111827" }}>{clientToDelete}</strong>?
                <br />Verranno eliminati anche <strong style={{ color: "#dc2626" }}>tutti i suoi ordini</strong>.
              </p>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button className="mcl-modal-cancel" onClick={() => setIsConfirmModalVisible(false)}>
                Annulla
              </button>
              <button className="mcl-modal-confirm" onClick={handleDeleteConfirmed}>
                Sì, elimina
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ManageClient;